// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Array, ArrayT, verifyArray } from "./array";
import { Bool, BoolT, verifyBool } from "./bool";
import { Byte, ByteT, verifyByte } from "./byte";
import { ByteString, ByteStringT, verifyByteString } from "./byte-string";
import { Data, unionToData, unionListToData } from "./data";
import { DateTime, DateTimeT, verifyDateTime } from "./date-time";
import { Double, DoubleT, verifyDouble } from "./double";
import {
  ExpandedNodeIdValue,
  ExpandedNodeIdValueT,
  verifyExpandedNodeIdValue,
} from "./expanded-node-id-value";
import { Float, FloatT, verifyFloat } from "./float";
import { Guid, GuidT, verifyGuid } from "./guid";
import { I16, I16T, verifyI16 } from "./i16";
import { I32, I32T, verifyI32 } from "./i32";
import { I64, I64T, verifyI64 } from "./i64";
import { LocalizedText, LocalizedTextT, verifyLocalizedText } from "./localized-text";
import { NodeIdValue, NodeIdValueT, verifyNodeIdValue } from "./node-id-value";
import {
  QualifiedNameValue,
  QualifiedNameValueT,
  verifyQualifiedNameValue,
} from "./qualified-name-value";
import { SByte, SByteT, verifySByte } from "./sbyte";
import { StatusCodeValue, StatusCodeValueT, verifyStatusCodeValue } from "./status-code-value";
import { String, StringT, verifyString } from "./string";
import { U16, U16T, verifyU16 } from "./u16";
import { U32, U32T, verifyU32 } from "./u32";
import { U64, U64T, verifyU64 } from "./u64";
import { XmlElement, XmlElementT, verifyXmlElement } from "./xml-element";

/**
 * A literal value operand in a where-clause.
 */
export class LiteralOperand implements flatbuffers.IUnpackableObject<LiteralOperandT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): LiteralOperand {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsLiteralOperand(bb: flatbuffers.ByteBuffer, obj?: LiteralOperand): LiteralOperand {
    return (obj || new LiteralOperand()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsLiteralOperand(
    bb: flatbuffers.ByteBuffer,
    obj?: LiteralOperand,
  ): LiteralOperand {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new LiteralOperand()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  valueType(): Data {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Data.NONE;
  }

  value<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startLiteralOperand(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addValueType(builder: flatbuffers.Builder, valueType: Data) {
    builder.addFieldInt8(0, valueType, Data.NONE);
  }

  static addValue(builder: flatbuffers.Builder, valueOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, valueOffset, 0);
  }

  static endLiteralOperand(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // value
    return offset;
  }

  static createLiteralOperand(
    builder: flatbuffers.Builder,
    valueType: Data,
    valueOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    LiteralOperand.startLiteralOperand(builder);
    LiteralOperand.addValueType(builder, valueType);
    LiteralOperand.addValue(builder, valueOffset);
    return LiteralOperand.endLiteralOperand(builder);
  }

  unpack(): LiteralOperandT {
    return new LiteralOperandT(
      this.valueType(),
      (() => {
        const temp = unionToData(this.valueType(), this.value.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: LiteralOperandT): void {
    _o.valueType = this.valueType();
    _o.value = (() => {
      const temp = unionToData(this.valueType(), this.value.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): LiteralOperandT {
    const t = new LiteralOperandT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value_type")) {
      t.valueType = this.valueType();
    }
    if (fieldSet.has("value")) {
      t.value = (() => {
        const temp = unionToData(this.valueType(), this.value.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class LiteralOperandT implements flatbuffers.IGeneratedObject {
  constructor(
    public valueType: Data = Data.NONE,
    public value:
      | ArrayT
      | BoolT
      | ByteStringT
      | ByteT
      | DateTimeT
      | DoubleT
      | ExpandedNodeIdValueT
      | FloatT
      | GuidT
      | I16T
      | I32T
      | I64T
      | LocalizedTextT
      | NodeIdValueT
      | QualifiedNameValueT
      | SByteT
      | StatusCodeValueT
      | StringT
      | U16T
      | U32T
      | U64T
      | XmlElementT
      | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.value === null || this.value === undefined) {
      throw new Error('Required field "value" is not set');
    }
    const value = builder.createObjectOffset(this.value);

    return LiteralOperand.createLiteralOperand(builder, this.valueType, value);
  }

  clone(): LiteralOperandT {
    const obj = new LiteralOperandT();
    obj.valueType = this.valueType;
    obj.value =
      this.value !== null && typeof (this.value as any).clone === "function"
        ? (this.value as any).clone()
        : this.value;
    return obj;
  }

  equals(other: LiteralOperandT): boolean {
    if (this.valueType !== other.valueType) return false;
    if (this.value !== null && other.value !== null) {
      if (typeof (this.value as any).equals === "function") {
        if (!(this.value as any).equals(other.value)) return false;
      } else if (this.value !== other.value) return false;
    } else if (this.value !== other.value) return false;
    return true;
  }
}

export function verifyLiteralOperand(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "value");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // Bool
            {
              const o = verifier.readInt32(pos);
              verifyBool(verifier, pos + o);
            }
            break;
          case 2: // SByte
            {
              const o = verifier.readInt32(pos);
              verifySByte(verifier, pos + o);
            }
            break;
          case 3: // Byte
            {
              const o = verifier.readInt32(pos);
              verifyByte(verifier, pos + o);
            }
            break;
          case 4: // U16
            {
              const o = verifier.readInt32(pos);
              verifyU16(verifier, pos + o);
            }
            break;
          case 5: // I16
            {
              const o = verifier.readInt32(pos);
              verifyI16(verifier, pos + o);
            }
            break;
          case 6: // U32
            {
              const o = verifier.readInt32(pos);
              verifyU32(verifier, pos + o);
            }
            break;
          case 7: // I32
            {
              const o = verifier.readInt32(pos);
              verifyI32(verifier, pos + o);
            }
            break;
          case 8: // U64
            {
              const o = verifier.readInt32(pos);
              verifyU64(verifier, pos + o);
            }
            break;
          case 9: // I64
            {
              const o = verifier.readInt32(pos);
              verifyI64(verifier, pos + o);
            }
            break;
          case 10: // Float
            {
              const o = verifier.readInt32(pos);
              verifyFloat(verifier, pos + o);
            }
            break;
          case 11: // Double
            {
              const o = verifier.readInt32(pos);
              verifyDouble(verifier, pos + o);
            }
            break;
          case 12: // String
            {
              const o = verifier.readInt32(pos);
              verifyString(verifier, pos + o);
            }
            break;
          case 13: // DateTime
            {
              const o = verifier.readInt32(pos);
              verifyDateTime(verifier, pos + o);
            }
            break;
          case 14: // Guid
            {
              const o = verifier.readInt32(pos);
              verifyGuid(verifier, pos + o);
            }
            break;
          case 15: // ByteString
            {
              const o = verifier.readInt32(pos);
              verifyByteString(verifier, pos + o);
            }
            break;
          case 16: // StatusCodeValue
            {
              const o = verifier.readInt32(pos);
              verifyStatusCodeValue(verifier, pos + o);
            }
            break;
          case 17: // LocalizedText
            {
              const o = verifier.readInt32(pos);
              verifyLocalizedText(verifier, pos + o);
            }
            break;
          case 18: // QualifiedNameValue
            {
              const o = verifier.readInt32(pos);
              verifyQualifiedNameValue(verifier, pos + o);
            }
            break;
          case 19: // NodeIdValue
            {
              const o = verifier.readInt32(pos);
              verifyNodeIdValue(verifier, pos + o);
            }
            break;
          case 20: // ExpandedNodeIdValue
            {
              const o = verifier.readInt32(pos);
              verifyExpandedNodeIdValue(verifier, pos + o);
            }
            break;
          case 21: // XmlElement
            {
              const o = verifier.readInt32(pos);
              verifyXmlElement(verifier, pos + o);
            }
            break;
          case 22: // Array
            {
              const o = verifier.readInt32(pos);
              verifyArray(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "value");
  } finally {
    verifier.popDepth();
  }
}
